import { Grid, Paper, TextField } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';

export default function TraspSimulazioniSrl(props: SimulazioniSrlInputProps) {
    const gClasses = globalStyles();

    const { state } = props;

    return (
        <React.Fragment>
            <Paper className={gClasses.mainPaper}>
            <SectionTitle primary={true} text="5° Simulazione - società trasparente - nessun compenso agli amministratori"></SectionTitle>
                <SectionTitle text="Società"></SectionTitle>
                <TextField
                    name="G48"
                    label="Ragione sociale"
                    value={state.datiSimulazioniSrl.G48}
                    className={gClasses.longTextFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="K62"
                            label="Utile di bilancio"
                            value={state.datiSimulazioniSrl.K62}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K63"
                            label="Variazioni fiscali in aumento"
                            value={state.datiSimulazioniSrl.K63}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K64"
                            label="Variazioni fiscali in diminuzione"
                            value={state.datiSimulazioniSrl.K64}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Reddito d'impresa - fiscale"
                            value={state.traspSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                        <Grid item></Grid>
                        <NumberField
                            name="I11"
                            label="Reddito d'impresa da attribuire ai soci"
                            value={state.traspSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                </Grid>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="1° Socio"></SectionTitle>
                <TextField
                    name="C52"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C52}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <NumberField
                    name="E118"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E118}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E119"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E119}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E120"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E120}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E121"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E121}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E122"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E122}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E123"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E123}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E32"
                    label="Reddito per trasparenza"
                    value={state.traspSimulazioniSrl.E32}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E124"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E124}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E125"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E125}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E127"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E127}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E38"
                    label="Reddito complessivo"
                    value={state.traspSimulazioniSrl.E38}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E39"
                    label="Redd. compl. per detraz."
                    value={state.traspSimulazioniSrl.E39}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="G23"
                    label="Redditi IVS"
                    value={state.traspSimulazioniSrl.G23}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="H23"
                    label="Contr. IVS"
                    value={state.traspSimulazioniSrl.H23}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <Grid container>
                    <NumberField
                        name="I25"
                        label="Oneri deducibili"
                        value={state.traspSimulazioniSrl.I25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I26"
                        label="Reddito imponibile"
                        value={state.traspSimulazioniSrl.I26}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I27"
                        label="Irpef lorda"
                        value={state.traspSimulazioniSrl.I27}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I29"
                        label="Familiari a carico"
                        value={state.traspSimulazioniSrl.I29}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I30"
                        label="Lavoro dipend."
                        value={state.traspSimulazioniSrl.I30}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I31"
                        label="Pensione"
                        value={state.traspSimulazioniSrl.I31}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I33"
                        label="Impresa/lav. Auton. e lav. non dipend."
                        value={state.traspSimulazioniSrl.I33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="L122"
                        label="Altre"
                        value={state.datiSimulazioniSrl.L122}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I35"
                        label="Tot. Detrazioni"
                        value={state.traspSimulazioniSrl.I35}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I37"
                        label="Irpef netta"
                        value={state.traspSimulazioniSrl.I37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K37"
                    label="Regionale"
                    value={state.traspSimulazioniSrl.K37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M37"
                    label="Comunale"
                    value={state.traspSimulazioniSrl.M37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="2° Socio"></SectionTitle>
                <TextField
                    name="C53"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C53}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <NumberField
                    name="E133"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E133}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E134"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E134}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E135"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E135}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E136"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E136}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E137"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E137}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E138"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E138}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E64"
                    label="Reddito per TRASPARENZA"
                    value={state.traspSimulazioniSrl.E64}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E139"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E139}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E140"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E140}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E142"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E142}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E70"
                    label="Reddito complessivo"
                    value={state.traspSimulazioniSrl.E70}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E71"
                    label="Redd. compl. per detraz."
                    value={state.traspSimulazioniSrl.E71}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="G55"
                    label="Redditi IVS"
                    value={state.traspSimulazioniSrl.G55}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="H55"
                    label="Contr. IVS"
                    value={state.traspSimulazioniSrl.H55}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <Grid container>
                    <NumberField
                        name="I57"
                        label="Oneri deducibili"
                        value={state.traspSimulazioniSrl.I57}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I58"
                        label="Reddito imponibile"
                        value={state.traspSimulazioniSrl.I58}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I59"
                        label="Irpef lorda"
                        value={state.traspSimulazioniSrl.I59}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I61"
                        label="Familiari a carico"
                        value={state.traspSimulazioniSrl.I61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I62"
                        label="Lavoro dipend."
                        value={state.traspSimulazioniSrl.I62}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I63"
                        label="Pensione"
                        value={state.traspSimulazioniSrl.I63}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I65"
                        label="Impresa/lav. Auton. e lav. non dipend."
                        value={state.traspSimulazioniSrl.I65}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="L137"
                        label="Altre"
                        value={state.datiSimulazioniSrl.L137}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I67"
                        label="Tot. Detrazioni"
                        value={state.traspSimulazioniSrl.I67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I69"
                        label="Irpef netta"
                        value={state.traspSimulazioniSrl.I69}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K69"
                    label="Regionale"
                    value={state.traspSimulazioniSrl.K69}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M69"
                    label="Comunale"
                    value={state.traspSimulazioniSrl.M69}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="3° Socio"></SectionTitle>
                <TextField
                    name="C54"
                    label="3° Socio"
                    value={state.datiSimulazioniSrl.C54}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <NumberField
                    name="E147"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E147}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E148"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E148}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E149"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E149}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E150"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E150}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E151"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E151}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E152"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E152}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E95"
                    label="Reddito per trasparenza"
                    value={state.traspSimulazioniSrl.E95}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E153"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E153}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E154"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E154}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E156"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E156}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E101"
                    label="Reddito complessivo"
                    value={state.traspSimulazioniSrl.E101}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E102"
                    label="Redd. compl. per detraz."
                    value={state.traspSimulazioniSrl.E102}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="G86"
                    label="Redditi IVS"
                    value={state.traspSimulazioniSrl.G86}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="H86"
                    label="Contr. IVS"
                    value={state.traspSimulazioniSrl.H86}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <Grid container>
                    <NumberField
                        name="I88"
                        label="Oneri deducibili"
                        value={state.traspSimulazioniSrl.I88}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I89"
                        label="Reddito imponibile"
                        value={state.traspSimulazioniSrl.I89}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I90"
                        label="Irpef lorda"
                        value={state.traspSimulazioniSrl.I90}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I92"
                        label="Familiari a carico"
                        value={state.traspSimulazioniSrl.I92}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I93"
                        label="Lavoro dipend."
                        value={state.traspSimulazioniSrl.I93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I94"
                        label="Pensione"
                        value={state.traspSimulazioniSrl.I94}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I96"
                        label="Impresa/lav. Auton. e lav. non dipend."
                        value={state.traspSimulazioniSrl.I96}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="L151"
                        label="Altre"
                        value={state.datiSimulazioniSrl.L151}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I98"
                        label="Tot. Detrazioni"
                        value={state.traspSimulazioniSrl.I98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I100"
                        label="Irpef netta"
                        value={state.traspSimulazioniSrl.I100}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K100"
                    label="Regionale"
                    value={state.traspSimulazioniSrl.K100}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M100"
                    label="Comunale"
                    value={state.traspSimulazioniSrl.M100}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />

            </Paper>
        </React.Fragment>
    )
}